import {ITranslation} from "../../../../types";

export enum EStatus {
    in_process = "in_process",
    confirmed = "confirmed",
    empty = "",

}

export interface IBaselineCreate {
    status: EStatus;
    academic_year_id: number;
    academic_term_id: number;
    learning_format_id: number;
    educational_degree_id:number;
    start_date:string
}

export interface IBaselinePayload {
    id:number,
    status: EStatus;
    academic_year_id: number;
    academic_term_id: number;
    start_date:string
    learning_format_id: number;
    educational_degree_id:number;
}




export interface IEducationalUnit {
    id: number;
    parent_id: number | null;
    status: number;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    translations: ITranslation[];
}


export interface IProfession {
    profession_id: number;
    translations: ITranslation[]
}

export interface IProgramTranslation {
    educational_program_id: number;
    slug: string;
    program_name: string;
    program_abbreviation: string;
}

export interface IEducationalProgram {
    educational_program_id: number;
    translations: IProgramTranslation[];
}

export interface IChildEducationalProgram {
    child_educational_program_id: number | null;
    translations: IProgramTranslation[];
}

export interface IReferenceGroup {
    id: number;
    reference_block_id: number;
    educational_unit_id: number;
    value: string;
}

export interface ICourse {
    course: number;
    student_count: number;
    reference_block_id: number;
    reference_groups: IReferenceGroup[];
}

export interface IReferenceBlockGrouped {
    profession: IProfession;
    educational_program: IEducationalProgram[];
    child_educational_program: IChildEducationalProgram;
    courses: ICourse[];
}

export interface IBaselineBlocks {
    educational_units: IEducationalUnit[];
    reference_data_id: number;
    max_course_number: number;
    reference_blocks_grouped: IReferenceBlockGrouped[];
}




export interface IInitialStateBaseline {
    baseline: IBaselinePayload[]
    baselineRestore: IBaselinePayload[]
    isViewBaselineRestore: boolean;
    isLoadingBaseline: boolean;
    selectedBaselineIDs:number[];
    baselineBlocks:IBaselineBlocks
}


